/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_TitleInputs */

const es_feedback_title = /** @type {(inputs: Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mis Feedbacks`)
};

const en_feedback_title = /** @type {(inputs: Feedback_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Feedback`)
};

/**
* | output |
* | --- |
* | "My Feedback" |
*
* @param {Feedback_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_title = /** @type {((inputs?: Feedback_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_title(inputs)
	return en_feedback_title(inputs)
});
export { feedback_title as "feedback.title" }